// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function HandsPrayingBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m29.769 22.148-4.441-4.442-4.522-14.918A3.219 3.219 0 0 0 16 1a3.22 3.22 0 0 0-4.806 1.788L6.672 17.706l-4.44 4.442a2.5 2.5 0 0 0 0 3.535l4.085 4.086a2.5 2.5 0 0 0 3.535 0l6.037-6.035c.039-.039.075-.078.111-.118.036.04.073.079.111.118l6.037 6.035a2.5 2.5 0 0 0 3.535 0l4.086-4.086a2.5 2.5 0 0 0 0-3.535ZM8.085 27.294 4.71 23.919l1.375-1.375 3.375 3.375-1.375 1.375Zm6.415-7.45a2.48 2.48 0 0 1-.732 1.767l-2.183 2.183-3.375-3.375.854-.854c.174-.174.303-.389.375-.625l4.625-15.279a.223.223 0 0 1 .435.065l.001 16.118Zm5.938 3.972-2.205-2.205a2.482 2.482 0 0 1-.733-1.767V3.719a.223.223 0 0 1 .435-.065l4.625 15.279c.071.236.2.45.375.625l.95.95-3.448 3.308Zm3.477 3.478-1.356-1.355 3.453-3.305 1.282 1.281-3.379 3.379Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
